export const ROLE_KEYS = {
  SUPER_ADMIN: 'superadmin',
  ADMIN: 'admin',
  AGENT_ADMIN: 'agentAdmin',
  AGENT: 'agent',
  CLIENT: 'client',
};

const normalizeRole = (value) => {
  if (!value) return '';
  const raw = String(value).trim();
  if (!raw) return '';
  const lower = raw.toLowerCase();
  const condensed = lower.replace(/[^a-z0-9]/g, '');
  if (condensed === 'superadmin') return ROLE_KEYS.SUPER_ADMIN;
  if (condensed === 'admin') return ROLE_KEYS.ADMIN;
  if (condensed === 'agentadmin') return ROLE_KEYS.AGENT_ADMIN;
  if (condensed === 'agent') return ROLE_KEYS.AGENT;
  if (condensed === 'client') return ROLE_KEYS.CLIENT;
  return raw;
};

export const getSessionRole = (session) => normalizeRole(
  session?.role ||
  session?.u_role ||
  session?.uRole ||
  session?.userRole ||
  session?.roleType
);

export const getDefaultRouteForRole = (session) => {
  const role = getSessionRole(session);
  if (role === ROLE_KEYS.SUPER_ADMIN || role === ROLE_KEYS.ADMIN) return '/admin/dashboard';
  if (role === ROLE_KEYS.AGENT_ADMIN) return '/agent-admin';
  if (role === ROLE_KEYS.AGENT) return '/agent';
  return '/';
};

export const isRoleAllowed = (session, allowedRoles = []) => {
  if (!allowedRoles || allowedRoles.length === 0) return true;
  const role = getSessionRole(session);
  const normalizedAllowed = allowedRoles.map(normalizeRole);
  return normalizedAllowed.includes(role);
};
